module.exports = {"home":"Homepage"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/en.json
// module id = NnYZ
// module chunks = 1